// Utility functions
function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// Global variable to store the uploaded file (as File object, not base64)
let uploadedFile = null;
let phoneInputInstance = null;

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  // Check if hash contains warranty code and pre-fill
  const hash = window.location.hash;
  if (hash) {
    const code = hash.replace('#', '');
    document.getElementById('warranty-code').value = code;
  }

  // Initialize phone input
  initPhoneInput();

  // Load places from API
  loadPlaces();

  // Setup form handlers
  setupFormHandlers();
});

// Initialize International Phone Input
function initPhoneInput() {
  const phoneInput = document.querySelector("#phone");
  const errorPhone = document.querySelector("#error-phone");
  const phoneNumberFull = document.querySelector("#phone-number-full");

  if (!phoneInput) return;

  phoneInputInstance = window.intlTelInput(phoneInput, {
    initialCountry: "auto",
    geoIpLookup: function(callback) {
      fetch('https://ipinfo.io/json?token=a5fbce6372f0e1')
        .then(response => response.json())
        .then(data => callback(data.country))
        .catch(() => callback("US"));
    },
    preferredCountries: ["us", "vn"],
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
  });

  // Handle phone number validation
  phoneInput.addEventListener("input", function() {
    if (phoneInput.value.trim()) {
      if (phoneInputInstance.isValidNumber()) {
        errorPhone.style.display = "none";
        phoneInput.classList.remove('has-error');
        phoneNumberFull.value = phoneInputInstance.getNumber();
      } else {
        errorPhone.textContent = "Invalid phone number. Please check the number and country code.";
        errorPhone.style.display = "block";
        phoneInput.classList.add('has-error');
      }
    } else {
      // Clear error when field is empty (will be caught on submit)
      errorPhone.style.display = "none";
      phoneInput.classList.remove('has-error');
    }
  });
}

// Load places from API
async function loadPlaces() {
  try {
    const response = await fetch('https://api.halio-sonic.com/v1/places', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to load places');
    }

    const data = await response.json();
    
    if (!data || !data.places || !data.places.data) {
      console.error('Invalid places data received');
      return;
    }

    const placesSelect = document.getElementById('places');
    
    // Add places to select
    data.places.data.forEach(item => {
      const option = document.createElement('option');
      option.value = item.attributes.id;
      option.textContent = item.attributes.name;
      placesSelect.appendChild(option);
    });

    // Add "Other" option
    const otherOption = document.createElement('option');
    otherOption.value = '-1';
    otherOption.textContent = 'Other';
    placesSelect.appendChild(otherOption);

    // Initialize Select2 if jQuery is available
    if (typeof jQuery !== 'undefined' && jQuery.fn.select2) {
      jQuery('#places').select2({
        placeholder: "Select a place",
        allowClear: true,
        dropdownCssClass: 'v02r-warranty-registration-form--places-dropdown',
      });

      // Handle place change with jQuery
      jQuery('#places').on('change', function(e) {
        handlePlaceChange(e);
      });
    } else {
      // Fallback to regular select
      placesSelect.addEventListener('change', handlePlaceChange);
    }

  } catch (error) {
    console.error('Error loading places:', error);
  }
}

// Handle place change
function handlePlaceChange(e) {
  const placeId = e.target.value;
  const otherPlaceInput = document.getElementById('other-place');
  
  if (placeId === '-1') {
    otherPlaceInput.classList.add('show');
    otherPlaceInput.required = true;
  } else {
    otherPlaceInput.classList.remove('show');
    otherPlaceInput.required = false;
    otherPlaceInput.value = '';
  }
}

// Setup form handlers
function setupFormHandlers() {
  const fileInput = document.getElementById('file');
  const form = document.getElementById('warranty-registration-form');

  // Handle file upload
  if (fileInput) {
    fileInput.addEventListener('change', handleFileUpload);
  }

  // Handle form submission
  if (form) {
    form.addEventListener('submit', handleFormSubmit);
  }

  // Add input event listeners to clear error state when user types
  document.querySelectorAll('.v02r-warranty-registration-form input, .v02r-warranty-registration-form select').forEach(input => {
    input.addEventListener('input', function() {
      clearFieldError(this);
    });
    input.addEventListener('change', function() {
      clearFieldError(this);
    });
  });
}

// Clear error state for a specific field
function clearFieldError(inputElement) {
  inputElement.classList.remove('has-error');
  
  // Find and hide the corresponding error message
  const fieldId = inputElement.id;
  const fieldName = inputElement.name;
  
  // Try to find error element by field ID or name
  const errorElement = document.getElementById(`error-${fieldId}`) || 
                       document.getElementById(`error-${fieldName}`) ||
                       document.getElementById(`error-${fieldId.replace(/-/g, '_')}`) ||
                       document.getElementById(`error-${fieldName?.replace(/_/g, '-')}`);
  
  if (errorElement) {
    errorElement.style.display = 'none';
    errorElement.textContent = '';
  }
}

// Handle file upload
function handleFileUpload(e) {
  const file = e.target.files[0];
  const errorFile = document.getElementById('error-receipt_bill');

  if (!file) {
    uploadedFile = null;
    return;
  }

  // Check file size (max 15MB)
  const maxSize = 15 * 1048576;
  if (file.size > maxSize) {
    errorFile.textContent = "File size must not exceed 15MB";
    errorFile.style.display = "block";
    e.target.classList.add('has-error');
    e.target.value = null;
    uploadedFile = null;
    return;
  }

  // Validate file format
  const allowedFormats = ['png', 'jpg', 'jpeg', 'gif', 'tiff'];
  const fileExtension = file.name.split('.').pop().toLowerCase();

  if (!allowedFormats.includes(fileExtension)) {
    errorFile.textContent = "Please upload a valid image file (PNG, JPG, JPEG, GIF, or TIFF)";
    errorFile.style.display = "block";
    e.target.classList.add('has-error');
    e.target.value = null;
    uploadedFile = null;
    return;
  }

  // File is valid - clear any previous errors
  errorFile.style.display = "none";
  e.target.classList.remove('has-error');

  // Store the actual File object (not base64)
  uploadedFile = file;
}

// Handle form submission
async function handleFormSubmit(e) {
  e.preventDefault();

  // Clear previous errors and error states
  document.querySelectorAll('.error-message-block').forEach(el => el.style.display = 'none');
  document.querySelectorAll('.v02r-warranty-registration-form input, .v02r-warranty-registration-form select').forEach(el => {
    el.classList.remove('has-error');
  });

  // Validate phone number
  const phoneInput = document.querySelector("#phone");
  const errorPhone = document.querySelector("#error-phone");
  const phoneNumberFull = document.querySelector("#phone-number-full");

  // Check if phone field is empty
  if (!phoneInput.value.trim()) {
    errorPhone.textContent = "Phone number is required";
    errorPhone.style.display = "block";
    phoneInput.classList.add('has-error');
    phoneInput.focus();
    phoneInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  // Check if phone number is valid
  if (phoneInputInstance && !phoneInputInstance.isValidNumber()) {
    errorPhone.textContent = "Invalid phone number. Please check the number and country code.";
    errorPhone.style.display = "block";
    phoneInput.classList.add('has-error');
    phoneInput.focus();
    phoneInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  } else if (phoneInputInstance) {
    phoneNumberFull.value = phoneInputInstance.getNumber();
    errorPhone.style.display = "none";
    phoneInput.classList.remove('has-error');
  }

  // Validate file upload
  if (!uploadedFile) {
    const errorFile = document.getElementById('error-receipt_bill');
    errorFile.textContent = "Please upload your bill image";
    errorFile.style.display = "block";
    document.getElementById('file').classList.add('has-error');
    document.getElementById('file').focus();
    document.getElementById('file').scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  // Validate place selection
  const placeId = document.getElementById('places').value;
  const errorPlace = document.getElementById('error-place_id');
  
  if (!placeId || placeId === '0' || placeId === '') {
    errorPlace.textContent = "Please select where you bought the product";
    errorPlace.style.display = "block";
    document.getElementById('places').classList.add('has-error');
    document.getElementById('places').focus();
    document.getElementById('places').scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  // If "Other" is selected, validate other place input
  if (placeId === '-1') {
    const otherPlace = document.getElementById('other-place').value.trim();
    const errorOtherPlace = document.getElementById('error-other_place');
    if (!otherPlace) {
      errorOtherPlace.textContent = "Please enter the store name or location";
      errorOtherPlace.style.display = "block";
      document.getElementById('other-place').classList.add('has-error');
      document.getElementById('other-place').focus();
      document.getElementById('other-place').scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
  }

  // Validate order number is not the same as phone number
  const orderNumber = document.getElementById('order-number').value;
  const phone = phoneInput.value;
  if (orderNumber === phone) {
    const errorOrderNumber = document.getElementById('error-order-number');
    errorOrderNumber.textContent = "Order number cannot be the same as phone number";
    errorOrderNumber.style.display = "block";
    document.getElementById('order-number').focus();
    document.getElementById('order-number').scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  // Show loader and disable button
  const submitButton = document.getElementById('submit-button');
  const loader = document.getElementById('loader');
  const buttonText = document.getElementById('button-text');
  
  submitButton.disabled = true;
  loader.style.display = 'inline-block';
  buttonText.style.display = 'none';

  try {
    const warrantyCode = document.getElementById('warranty-code').value;
    
    // Build FormData with all fields nested under "registration[field_name]"
    // to match the API format: registration[name], registration[phone], etc.
    const formData = new FormData();
    
    // Add code as query parameter (will be in URL)
    // Add all registration fields with registration[field_name] format
    formData.append('registration[order_number]', document.getElementById('order-number').value);
    formData.append('registration[name]', document.getElementById('full-name').value);
    formData.append('registration[email]', document.getElementById('email').value);
    formData.append('registration[phone]', phoneInputInstance ? phoneInputInstance.getNumber() : phoneInput.value);
    formData.append('registration[purchase_date]', document.getElementById('purchase-date').value);
    
    // Add file if uploaded
    if (uploadedFile) {
      formData.append('registration[receipt_bill]', uploadedFile);
    }
    
    // Add place_id or other_place
    if (placeId === '-1') {
      formData.append('registration[place_id]', '');
      formData.append('registration[other_place]', document.getElementById('other-place').value);
    } else {
      formData.append('registration[place_id]', placeId);
      formData.append('registration[other_place]', '');
    }

    console.log('Sending FormData request with code:', warrantyCode);

    // Submit to API using FormData (multipart/form-data)
    // Note: Don't set Content-Type header - browser will set it automatically with boundary
    const response = await fetch(`https://api.halio-sonic.com/v1/registrations?code=${warrantyCode}`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: formData
    });

    const result = await response.json();

    if (response.status === 404) {
      alert("Your code is not correct. Please try again.");
      return;
    }

    const responseMessage = result?.errors || result?.messages;

    if (responseMessage === "This code is registered!") {
      // Show success message
      document.getElementById('warranty-registration-form').style.display = 'none';
      const successMessage = document.getElementById('success-message');
      successMessage.querySelector('.message').textContent = 'Your code has been registered. Redirecting to your warranty information...';
      successMessage.style.display = 'flex';
      successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
      
      // Redirect after 2 seconds
      setTimeout(() => {
        window.location.href = `https://halio-sonic.com/pages/check-warranty-information?auto_submit=true#${warrantyCode}`;
      }, 2000);
      return;
    }

    if (response.status === 200 || response.ok) {
      // Check if successful
      if (result.success) {
        // Show success message
        document.getElementById('warranty-registration-form').style.display = 'none';
        const successMessage = document.getElementById('success-message');
        successMessage.style.display = 'flex';
        successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        // Redirect after 2 seconds
        setTimeout(() => {
          window.location.href = `https://halio-sonic.com/pages/check-warranty-information?auto_submit=true#${warrantyCode}`;
        }, 2000);
        return;
      } else if (result.errors) {
        // Display validation errors
        displayErrors(result.errors);
        return;
      }
    }

    if (response.status === 400) {
      // Handle validation errors
      if (result.errors && typeof result.errors === 'object') {
        displayErrors(result.errors);
      } else {
        alert(responseMessage || "There was an error with your submission. Please check your information and try again.");
      }
      return;
    }

    if (response.status === 422) {
      // Unprocessable Entity - validation errors
      if (result.errors && typeof result.errors === 'object') {
        displayErrors(result.errors);
      } else {
        alert("Please check your information and try again.");
      }
      return;
    }

    alert("Something went wrong. Please try again.");

  } catch (error) {
    console.error('Form submission error:', error);
    alert("An error occurred. Please try again later.");
  } finally {
    submitButton.disabled = false;
    loader.style.display = 'none';
    buttonText.style.display = 'inline';
  }
}

// Display errors function
function displayErrors(errors) {
  // First, remove all existing error states
  document.querySelectorAll('.v02r-warranty-registration-form input, .v02r-warranty-registration-form select').forEach(el => {
    el.classList.remove('has-error');
  });

  for (const field in errors) {
    const errorMessages = Array.isArray(errors[field]) ? errors[field] : [errors[field]];
    const errorMessage = errorMessages.join(", ");
    const errorElement = document.getElementById(`error-${field}`);
    
    if (errorElement) {
      // Capitalize field name for display
      const fieldName = field === 'order_number' ? 'Order number' :
                       field === 'receipt_bill' ? 'Bill image' :
                       field === 'purchase_date' ? 'Purchase date' :
                       field === 'place_id' ? 'Place' :
                       field === 'other_place' ? 'Other place' :
                       capitalize(field.replace(/_/g, ' '));
      
      errorElement.textContent = `${fieldName} ${errorMessage}`;
      errorElement.style.display = 'block';
      
      // Highlight the input field with error
      const inputElement = document.getElementById(field) || 
                          document.getElementById(field.replace(/_/g, '-')) ||
                          document.querySelector(`[name="${field}"]`);
      
      if (inputElement) {
        inputElement.classList.add('has-error');
      }
      
      // Scroll to first error
      if (Object.keys(errors)[0] === field) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }
}
